import ModalBase from './ModalBase';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { FormatEuroCents } from '../utilities/utilities';

const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        flexDirection: "column",
        minWidth: "320px",
        '& .title': { fontWeight: 700 },
        '& .amount-row': { display: "flex", justifyContent: "space-between", padding: "6px 0" },
        '& .MuiButtonBase-root': { marginTop: "16px" },
    },
}));

function CashPaymentDialog({ totalAmountCents, totalAmountCashCents, amountPaidCents, remainingCents, changeOwedCents, status, onCancel }) {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <ModalBase>
            <div id="cashPaymentDialog" className={classes.root}>
                <h2 className="title">{t('cash.pay-with-cash')}</h2>

                <div className="amount-row"><span>{t('cash.total')}</span><span>{FormatEuroCents(totalAmountCents)}</span></div>
                <div className="amount-row"><span>{t('cash.total-cash')}</span><span>{FormatEuroCents(totalAmountCashCents)}</span></div>
                <div className="amount-row"><span>{t('cash.paid')}</span><span>{FormatEuroCents(amountPaidCents)}</span></div>
                <div className="amount-row"><span>{t('cash.remaining')}</span><span>{FormatEuroCents(remainingCents)}</span></div>
                <div className="amount-row"><span>{t('cash.receiving-back')}</span><span>{FormatEuroCents(changeOwedCents)}</span></div>

                {status === 'complete' ? <h3 className="green">{t('cash.payment-complete')}</h3> : null}
                {status === 'error' ? <h3 className="red">{t('cash.payment-error')}</h3> : null}

                <Button
                    onClick={onCancel}
                    disabled={status === 'complete'}
                    variant="contained"
                    className="red-btn"
                >{t('cash.cancel-flush')}</Button>
            </div>
        </ModalBase>
    );
}

export default CashPaymentDialog;
